export const PREVIEW_NAV_WRAP_CLASS_NAME =
  'center-y property-opacity-translate absolute z-10 hidden duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none lg:pointer-fine:block lg:pointer-fine:pointer-events-none lg:pointer-fine:opacity-0';

export const PREVIEW_IMAGE_SIZES =
  '(min-width: 1280px) 776px, (min-width: 1024px) calc(100vw - 480px), (min-width: 768px) calc(100vw - 80px), calc(100vw - 32px)';

export const PREVIEW_MOBILE_WIDTHS = [
  640, 750, 828, 1080, 1280, 1440, 1680, 1920,
] as const;

export const PREVIEW_DESKTOP_WIDTHS = [1280, 1440, 1680] as const;

export const PREVIEW_IMAGE_PARAMS = { ar: '16-9' } as const;

export const IMAGE_PRELOAD_OFFSET = '100% 0px';
